import React from "react";

import { Outlet } from "react-router-dom";
import "./layout.css";

const Layout = () => {
  return (
    <div className="layout">
      <div className="layout-body">
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
